import { InputLabel, makeStyles } from "@material-ui/core";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router";
import { IsAuthorization } from "../../../../../../app";
import { getTreeData } from "../../../../../../utils/helper";
import { GameTagEnum, IGame } from "../../type";
import { Checkbox, Row, Tag, TreeSelect } from "antd";
import { FormButton } from "../../../../../common";

interface ILobbyPriorityProps {
  allGames: IGame[];
}

const useStyle = makeStyles(() => ({
  allGameWrapper: {
    overflowX: "auto",
    display: "flex",
    // justifyContent: "center"
  },
  gameWrapper: {
    minHeight: "10vh",
    minWidth: "20%",
    margin: "2.5%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  title: {
    fontSize: 22,
    padding: 5,
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const LobbyPriority = ({ allGames = [] }: ILobbyPriorityProps) => {
  const auth = useContext(IsAuthorization);
  const { t } = useTranslation();
  const classes = useStyle();

  return !auth.login ? (
    <Redirect to="/login" />
  ) : (
    <>
      <div className={classes.allGameWrapper}>
        {allGames.map((game, index) => {
          return (
            <div className={classes.gameWrapper} key={`${game}${index}`}>
              <div className={classes.center}>
                <Tag color="#3C7082" className={classes.title}>
                  {index}
                </Tag>
              </div>

              <InputLabel
                shrink={true}
                // style={{ color: error ? "red" : "initial" }}
              >
                {t("GameManagement.gameID")}
              </InputLabel>
              <TreeSelect
                value={game.gameID}
                treeData={getTreeData(
                  allGames.map((g) => g.gameID),
                  false
                )}
              />
              <Checkbox.Group value={game.tags}>
                <Row justify="center" style={{ marginTop: 10 }}>
                  <Checkbox value={GameTagEnum.hot}>
                    <Tag color="#E06C75">{GameTagEnum.hot}</Tag>
                  </Checkbox>
                </Row>
                <Row justify="center" style={{ marginTop: 10 }}>
                  <Checkbox value={GameTagEnum.new}>
                    <Tag color="#286FD4">{GameTagEnum.new}</Tag>
                  </Checkbox>
                </Row>
                <Row justify="center" style={{ marginTop: 10 }}>
                  <Checkbox value={GameTagEnum.recommend}>
                    <Tag color="#8DB570">{GameTagEnum.recommend}</Tag>
                  </Checkbox>
                </Row>
              </Checkbox.Group>
            </div>
          );
        })}
      </div>
      <div style={{ float: "right", marginTop: 10 }}>
        <FormButton cancelEvent={() => {}} disable={false} okEvent={() => {}} />
      </div>
    </>
  );
};

export default LobbyPriority;
